import { default as AccessFeatureUpgradePlanButtonBase } from './Base';
import { default as AccessFeatureUpgradePlanButtonContactSales } from './ContactSales';
import { default as AccessFeatureUpgradePlanButtonShowPlan } from './ShowPlan';

export const AccessFeatureUpgradePlanButtonComponents = {
  Base: AccessFeatureUpgradePlanButtonBase,
  ContactSales: AccessFeatureUpgradePlanButtonContactSales,
  ShowPlan: AccessFeatureUpgradePlanButtonShowPlan,
};
